<!--
 * @Author: 邓诗敏
 * @Date: 2022/9/15 15:22
 * @Description: 班组记账，收入、支出表单弹窗
-->
<template>
  <div>
    <el-button
      class="btn-record"
      @click="open()"
      :type="billType == 1 ? 'default' : 'primary'"
      >记{{ typeText }}</el-button
    >
    <el-dialog
      :visible="visible"
      :title="'记' + typeText"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="beforeClose"
      width="800px"
      custom-class="editindividualrecord"
    >
      <div class="currentProject">当前项目：<span style="font-weight:700">{{ projectName }}</span></div>
      <el-form
        :model="form"
        :rules="rules"
        label-width="110px"
        label-position="right"
        ref="formRef"
        class="form"
      >
        <!-- 金额 -->
        <el-form-item
          class="input_amount"
          label="金额（元）："
          prop="billAmount"
          :rules="[
            {
              required: true,
              message: `请输入${typeText}金额`,
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            v-model="form.billAmount"
            :placeholder="'请输入' + typeText + '金额'"
            v-input-limit="/^((\d{0,6})|(\d{1,6}\.(\d{1,2})?))$/"
          ></el-input>
        </el-form-item>

        <!-- 收入/支出类型 -->
        <el-form-item
          class="inputtype"
          :label="typeText + '类型：'"
          prop="billCostType"
          :rules="[
            {
              required: true,
              message: `请选择${typeText}类型`,
              trigger: 'change'
            }
          ]"
        >
          <el-radio-group v-model="form.billCostType">
            <el-radio-button
              v-for="(item, index) in radioList"
              :key="index"
              :label="index + 1"
            >
              {{ item }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择工人："
          prop="settleWorkerNo"
          v-if="this.billType == 2"
          ref="formSelectWorker"
          class="input_amounts"
        >
          <el-button
            style="height: 34px; padding: 0px 15px;color:#666"
            @click="$refs.selectWorker.open(form.settleWorkerNo)"
            >选择工人 ></el-button
          >
          <span
            style="margin-left: 16px"
            v-if="workerInfoArr && workerInfoArr.length"
            >已选择{{ workerInfoArr[0].name }}等{{
              form.settleWorkerNo.length
            }}人</span
          >
        </el-form-item>
        <!-- 日期 -->
        <el-form-item label="日期：" prop="billDate" class="input_amounts">
          <el-input
            :value="form.billDate"
            @focus="$refs.selectCalendar.open()"
          ></el-input>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注：" style="margin-bottom: 0">
          <el-input
            class="input-remark"
            show-word-limit
            resize="none"
            type="textarea"
            placeholder="请填写备注"
            :maxlength="30"
            v-model="form.remark"
            @keydown.native.enter.prevent
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div slot="footer">
        <el-button @click="beforeClose" style="width:58px;height:34px;padding:0 15px">取消</el-button>
        <el-button @click="save" type="primary" style="width:58px;height:34px;padding:0 15px;margin-left: 20px"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择日历弹窗组件 -->
    <SelectCalendar
      ref="selectCalendar"
      :redio="true"
      :value.sync="form.billDate"
    />
    <!-- 选择工人弹窗 -->
    <select-worker ref="selectWorker" @save="saveWorker" isBzjz></select-worker>
    <!-- 记账成功弹窗 -->
    <AccountSuccess ref="AccountSuccess" :visible.sync="successVisible" />
    <!-- 无项目时新建项目弹窗 -->
    <projectEdit ref="projectEdit" isNewProject  @editend="getNewProject()"></projectEdit>
  </div>
</template>
<script>
import { api } from "@/api/apiIndividualRecord"
import moment from "moment"
export default {
  name: "AddIncomeExpenses",
  components: {
    SelectCalendar: () =>import("@/views/record/components/statistics/statisticsBtn/components/selectCalendar.vue"), // 选择日历弹窗组件
    AccountSuccess: () => import("@/views/TeamRecord/components/AccountSuccess.vue"), // 记账成功弹窗
    SelectWorker: () =>import("@/views/record/components/statistics/statisticsBtn/components/SelectWorker.vue"), // 选择工人弹窗
    projectEdit: () => import("@/views/record/components/projectEdit"),//新建项目弹窗
  },
  props: {
    //记账类型,1:收入  2:支出
    billType: {
      type: [Number, String],
      default: 1
    },
    //项目
    project: {
      type: [Object, undefined],
      default() {
        return {}
      }
    },
    projectName: {
      type: [String, undefined],
      default: ""
    },
    projectNo: {
      type: [String, undefined],
      default: ""
    },
    //项目列表
    projectlist: {
      type: [Array, undefined],
      default() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false,
      successVisible: false, //记账成功弹窗
      workerInfoArr: [],
      form: {
        billAmount: "", // 金额
        billCostType: "", // 消费类型
        billDate: "", // 日期（单选）
        remark: "", // 备注
        settleWorkerNo: [], //选择工人的no
        settleProjectNo: "" //项目编号
      },
      radioList: [], // 收入支出类型
      incomeType: ["工程款", "项目部用工", "其他"], // 类型为收入时的单选类型
      expensesType: ["工资发放","材料费","生活用品","交通","医疗","吃饭","娱乐","住宿","其他"], // 类型为支出时的单选类型
      rules: {
        billDate: [{ required: true, message: "请选择日期", trigger: "blur" }],
        projectName: [
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
            message: "只能输入中文、英文、数字"
          },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15) callback(new Error("最多15位字符"))
              else if (value.length == 0) callback(new Error("请输入项目名称!"))
              else callback()
            },
            trigger: "blur"
          }
        ]
      },
      recordType: "", // 类型： 1 个人  2 班组
      loading: false,
      showEdit: false,
      forms: {
        projectName: ""
      }
    }
  },
  methods: {
    //打开记账弹窗
    open(row) {
      if (this.billType == 1) {
        // 收入
        this.radioList = this.incomeType
      } else if (this.billType == 2) {
        // 支出
        this.radioList = this.expensesType
      }
      this.recordType = this.$route.query.type ? this.$route.query.type : "1"
      this.form = {
        billAmount: "",
        billCostType: "",
        billDate: this.getToDay(),
        remark: "",
        settleProjectNo:'',
        settleWorkerNo:[]
      }
      //编辑
      if(row){
        let items =JSON.parse(JSON.stringify(row))
        items.billDate=moment(items.billDate).format('YYYY-MM-DD') // 时间戳格式化为 YYYY-MM-DD
        /* 处理工友 回显 */
        this.workerInfoArr=items.settleWorkerList ? items.settleWorkerList : ''
        items.settleWorkerList=items.settleWorkerList ? items.settleWorkerList.map(v=> v.no) : []
        let {billAmount, billCostType, billDate, remark , settleProjectNo , settleWorkerList , no} = items
        this.form={billAmount, billCostType, billDate, remark , settleProjectNo , settleWorkerNo:settleWorkerList , no }
      }
      if (!this.projectlist.length) {
        this.$refs.projectEdit.open()
      } else if (this.project.length !== 0) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.formRef.clearValidate()
        })
      }
    },
    /* 无项目点收入支出新建项目 */
    getNewProject(){
      this.$emit('close')
      this.$nextTick(v=>{
        if (this.billType == 1) { // 收入
        this.radioList = this.incomeType
      } else if (this.billType == 2) { // 支出
        this.radioList = this.expensesType
      }
      this.recordType = this.$route.query.type ? this.$route.query.type : '1'
      this.form = {
        billAmount: '',
        billCostType: '',
        billDate: this.getToDay(),
        remark: '',
        settleProjectNo:'',
        settleWorkerNo:[]
      }
      this.visible=true
      })
    },
    //新增项目
    async edit() {
      if (this.loading) return
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.forms.userNo = this.$store.state.user.no
        this.forms.type = "4" //1:个人记工,2:班组记工3:个人记账,,4:班组记账
        this.loading = true
        let res = await api.addTenderMoney(this.forms)
        if (res.data.code == 200) {
          this.showEdit = false
          this.visible = true
          this.$message.success(res.data.msg)
          this.$emit("editend", res.data.data)
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    cancel() {
      // this.$refs.forms&&this.$refs.forms.clearValidate();
      this.forms.projectName = ""
      this.showEdit = false
    },
    //获取当天日期  格式：YYYY-MM-DD
    getToDay() {
      return moment(new Date()).format("YYYY-MM-DD")
    },
    //关闭记账弹窗
    beforeClose() {
      this.visible = false
      this.form = {
        billAmount: "",
        billCostType: "",
        billDate: this.getToDay(),
        remark: "",
        settleProjectNo:'',
        settleWorkerNo:[]
      }
      this.$nextTick(() => {
        this.form.settleWorkerNo = []
        this.workerInfoArr = []
      })
      this.$refs.formRef.clearValidate()
    },
    //保存选择的工人
    saveWorker(v, workerInfoArr) {
      //处理被删除的工人数据
      this.workerInfoArr = workerInfoArr.filter(v=>{ return  Object.prototype.toString.call(v) === "[object Object]"})
      this.form.settleWorkerNo = this.workerInfoArr.map(v=>v.no)
      this.$refs.formSelectWorker.validate()
    },
    //保存记账
    save() {
      if (this.loading) return
      this.loading = true
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          const params = { ...this.form }
          params.billCostName = this.radioList[params.billCostType - 1] // 获取消费类型的文字
          params.type = this.recordType // 个人记账/班组记账
          params.billType = this.billType // 收入/支出
          if (params.billType == 2) {
            params.settleWorkerNo = this.form.settleWorkerNo
          }
          params.settleProjectNo = this.projectNo
          const res = await api.settleBillTeamAdd(params)
          if (res.data.code === 200) {
            this.beforeClose()
            this.successVisible = true
            this.$emit("close")
          } else {
            this.$message.error("系统异常，请稍后再试")
          }
        }
        this.loading = false
      })
    },
    //根据记账no获取记账详情
    async getDetail(row) {
      const res = await api.settleBillDetail(no)
      if (res.data.code === 200) {
        res.data.data.billDate = moment(res.data.data.billDate).format("YYYY-MM-DD") // 时间戳格式化为 YYYY-MM-DD
        this.form = res.data.data
      } else {
        this.$message.error("系统异常，请稍后再试")
      }
    }
  },
  computed: {
    /*** 记账类型的文字，用于表单显示*/
    typeText() {
      return this.billType == 1 ? "收入" : "支出"
    }
  }
}
</script>

<style lang="scss" scoped>
.c666 {
  color: #666;
}
/deep/.editindividualrecord{
  .el-dialog__body {
    border-top: 0px;
    padding: 0 !important;
  }
  .el-dialog__footer {
    text-align: center;
    padding: 20px 0px!important;
  }
}
/deep/ .el-dialog {
  .el-dialog__body {
    border-top: 0px;
    // padding: 0 !important;
  }

  .el-dialog__footer {
    text-align: center;
    padding:0 20px 20px;
  }
  .currentProject {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    background-color: #f5f7fa;
    font-size: 16px;
    color: #000;
  }
}

.form {
  font-size: 14px;
  padding: 20px 120px 0 119px !important;
  .el-form-item {
    margin-bottom: 15px;
    // height: 34px;
  }

  .el-input {
    width: 450px;
    height: 34px;
  }
  /deep/.el-form-item__error{
    padding-top: 0;
  }
  /deep/ .el-form-item__label {
    color: #000000;
    line-height: 34px;
  }

  /deep/ .el-input__inner {
    height: 34px;
    color: #666666;
  }

  /deep/ .el-radio-button {
    margin: 10px 20px 0 0;
  }

  /deep/ .el-radio-button__inner {
    padding: 9px 14px;
    border-radius: 4px !important;
    border: 1px solid #e4e7ed;
    color: #666666;
  }

  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #0286df;
    background-color: #fff;
    border-color: #0286df;
    box-shadow: none;
  }

  .input-remark {
    width: 450px;
    height: 68px;

    /deep/ .el-textarea__inner {
      height: 68px;
      padding: 8px 15px;
    }

    /deep/ .el-input__count {
      background: none;
      bottom: -3px;
      right: 17px;
      color: #c0c4cc;
      font-size: 14px;
    }
  }

  .input_amount {
    margin-bottom: 5px;

    /deep/ .el-form-item__content {
      height: 34px;
      line-height: 34px;
    }
  }
  .input_amounts {
    margin-bottom: 15px;

    /deep/ .el-form-item__content {
      height: 34px;
      line-height: 34px;
    }
  }
  /deep/.inputtype {
    margin-bottom: 15px;
  .el-form-item__label{
    margin-top: 10px;
  }
    /deep/ .el-form-item__content {
      height: 34px;
      line-height: 34px;
    }
  }
}

.el-button.btn-record {
  font-size: 14px;
  // padding: 8px 15px;
  border-radius: 0;
  border: 1px solid #b79255;
  width: 86px;
  height: 34px;
  line-height: 34px;
  padding: 0;
  &.el-button--default {
    color: #b79255;
    margin-right: 10px;
    &:hover,
    &:focus {
      color: #b79255 !important;
      background: #fff;
      border-color: #b79255 !important;
    }
  }

  &.el-button--primary {
    color: #ffffff;
    background: #b79255;
  }
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
  height: 44px;
  line-height: 44px;
  padding:0 20px!important;
}
/deep/.el-dialog__headerbtn {
    top: 12px;
}
/deep/.el-dialog__title {
  line-height: 44px;
  color: #000;
}
/deep/.el-dialog__footer {
  padding-top: 18px;
  padding-bottom: 40px;
}
/deep/.el-button + .el-button {
  margin-left: 20px;
}
/deep/.el-input {
  .el-input__inner {
    height: 34px !important;
  }
}

.content {
  padding: 20px;
}
/deep/.checkbutton {
  color: #969696;
  background: #fff;
  border-color: #e4e7ed !important;
  width: 86px;
  height: 34px;
  line-height: 34px;
  padding: 0;
  border-radius: 4px!important;
  &:hover{
  color: #969696;
  background: #fff;
  border-color: #e4e7ed !important;
  }
}
.checkbuttons {
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  width: 86px;
  height: 34px;
  line-height: 34px;
  padding: 0;
  font-size: 14px;
  border-radius: 4px!important;
  &:hover{
  color: #fff;
  border-color: #b79255;
  background: #b79255;
  }
}
</style>

